<template>
  <div class="testpaper">
    <!-- <div class="header">
      <div class="contain header_wrap">
        <div class="icon">
          <img src="../../assets/icons/icon.png" alt>
        </div>
        <div class="title">
          试卷预览
        </div>
        <div class="back" @click="$router.go(-1)">返回</div>
      </div>
    </div> -->
        <div class="header">
      <div class="contain header_wrap">
        <div class="icon">
          <img src="../../assets/icons/icon.png" alt>
        </div>
        <div class="title">
          {{message.eptitle?message.eptitle:"预览试卷"}}<span v-if="!message.eptitle" style="font-size:10px;color:red;">标题未定</span>   
          <div class="record">
            <span>
             总题数
            {{message.epcount}}
            </span>
            <span>
              总分
              <em>{{message.epscore}}</em>
              分
            </span>
          </div>
        </div>
        <div class="back" @click="$router.go(-1)">返回</div>
      </div>
    </div>
    <div class="div"></div>
    <div class="main contain_main">
      <div class="issueitem" v-for="(issuelist,index) in list" :key="'issue'+index">
        <div class="title">
          {{issuelist.title}}
          <!-- <span>（共{{issuelist.count}}题，{{issuelist.score}}分）</span> -->
        </div>
        <issue
          v-for="(item,order) in issuelist.questions"
          :key="'item'+order"
          :total="issuelist.questions.length"
          :order="(order+1)"
          :message="item"
          :disabled='true'
          :showasw="false"
        ></issue>
      </div>
    </div>
    <div style="height:300px"></div>
  </div>
</template>

<script>
import issue from "../../components/issue";
export default {
  name: "scanpaper",
  data() {
    return {
      list: [],
      message:{
        eptitle:null
      }
    };
  },
  components: {
    issue
  },
  mounted() {
      if(!this.$route.params.message){
          this.errorPlus("没有预览的题目")
          this.$router.go(-1)
          return 
      }
      this.list =this.$route.params.message.epquestions,
      this.message = this.$route.params.message
  },
  methods: {
  }
};
</script>
<style lang="css" scoped>
.header {
  height: 0.8rem;
  width: 100%;
  border: 1px solid #e8e9ee;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.header .title {
  min-width: 200px;
}
.div {
  display: block;
  content: "";
  height: 0.75rem;
  border: #474dff 1px solid;
}
.header_wrap {
  display: flex;
  justify-content: space-between;
  line-height: 0.75rem;
}
.record {
  position: absolute;
  bottom: 0rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.12rem;
  line-height: 0.2rem;
  width: 200%;
  color: #333;
  display: flex;
  justify-content: space-around;
}
em {
  color: red;
}
.header_wrap .title {
  font-size: 0.26rem;
  color: #474dff;
  position: relative;
}
.header_wrap .back {
  width: 1.1rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  display: inline-block;
  line-height: 0.3rem;
  margin-top: 0.22rem;
}
.main .title {
  font-size: 0.24rem;
  text-align: left;
  margin-top: 0.6rem;
}
.title span {
  font-size: 0.12rem;
  color: "#777f90";
}
</style>


// WEBPACK FOOTER //
// src/pages/scan/scanpaper.vue